const config = {
    ONLINE_BOOKING_BACKEND_V2 : 'https://obbv2demo.shipsy.in',
    PROJECT_X_URL: "https://demodashboardapi.shipsy.in",
    GOOGLE_RECAPTCHA_SITE_KEY: "6Ld8BOQUAAAAAHjZ7AyFHmMUlr1gyXjyXFER9GYX",
    ORGANISATION_LOGO_URL:
      "https://s3-us-west-2.amazonaws.com/shipsy-public-assets/Zajil/Zajil.jpg",
    applicationType: "zajilebooking",
    DEFAULT_PRETTY_NAME: "shipsyflamingo", //org for which you are testing
    organisationId: "shipsyflamingo", //org for which you are testing
    hardcodedDataOrgs: ["ZAJIL"],
    hideAreaCodeOrgs: ["FLOWPL", "epickmeup"],
    apiKey: "8tskcdaRpARZQTu2JCjMAmdBBkpEsk2u",
    RIDER_ONBOARDING_FORM_COMPONENT: {
      "ncubate": "DealshareRiderOnboardingForm",
    },
    ORG_LEVEL_ONBOARDING_CONFIG: {
      "ncubate": {
        "AADHAAR_GENERATION_URL": "https://wbdemo.shipsy.io/webhook/ncubate/generate-aadhaar-otp",
        "AADHAAR_VALIDATION_URL": "https://wbdemo.shipsy.io/webhook/ncubate/validate-aadhaar-otp",
        "SUBMIT_URL": "https://wbdemo.shipsy.io/webhook/ncubate/onboard-worker",
        "apiKey": "717cd71445979c1b9c0c30eeafd0a7",
      }
    }
  };
  export default config;
